<!-- <div class="breadcrumb-dev">
    <ul class="nav ace-breadcrumb" style="height:35px;">
       
          <li>
          <a class="nav-link active" aria-current="true" href="https://{{urlDomain}}/Home/Dashboard">
            <span style="font-family:Rajdhani;font-size:20px;top:-px;position:relative;">Home</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" href="https://{{urlDomain}}/TenantProfile/CompanyProfileLanai">
            <span style="font-family:Rajdhani;font-size:20px;top:-0px;position:relative;">Company Profile</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled">
            <span style="font-family:Rajdhani;font-size:20px;top:-0px;position:relative;">Parker Profile</span>
          </a>
        </li>
    </ul>
  </div>
  <br /> -->
  <div style="margin-left:10px;margin-top:5px;">
    <button mat-fab color="primary" 
        matTooltip="Return to Parker Profile"
        aria-label="Return to Parker Profile" 
        (click)="onNavToParkersHome()"
        style="margin-top:20px;margin-left:20px;">
        <mat-icon>arrow_back</mat-icon>
    </button>
    </div>

<div class="container-full" style="margin-top:20px;">
    <div style="margin-left:20px;margin-top:10px;">
        <span class="lanai-page-title">spACE APN Activation Administration for Lot {{lotDisplayName}} </span>
    </div>
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>

          <div class="row" style="width:100%;">
            <div class="col-12">
              <span style="font-size:16px;font-weight: bold;margin-left:5px;">Select Activation Type:</span>
            </div>
          </div>
            <div class="row" style="width:100%;margin-top:5px">
                <div class="col-4">
                    <mat-form-field appearance="fill" style="width:100%;">
                        <mat-label>spACE Activation Type</mat-label>
                        <mat-select style="width:100%" [typeaheadDebounceInterval]="500"  (selectionChange)="onQueryTypeChange($event.value)" >
                        <mat-option value="0">Select Activation Type</mat-option>
                        <mat-option  value="1">New spACE Activation(s)</mat-option>
                        <mat-option  value="2">Non-Active spACE Accounts</mat-option>
                        </mat-select>
                        <mat-error>
                            Selecting a spaCE Account Type is <strong>required</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

        <ng-container *ngIf="queryType == '1'">
            <app-parker-v2-accounts-to-activate></app-parker-v2-accounts-to-activate>            
        </ng-container> 

        <ng-container *ngIf="queryType == '2'">
           <app-parker-v2-non-active-space-accounts></app-parker-v2-non-active-space-accounts>
        </ng-container>
      
        </mat-card-content>
        <mat-card-actions style="margin-top:20px;">
            
      </mat-card-actions>
  
    </mat-card>                                                                             

    
    <!-- </div> -->


</div>


